import { getDateTime, isDateOverdue } from "lib/dates";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "@alm/flow-ds/components";

interface Props {
	date: string;
}

export default function DueDate({ date }: Props) {
	const { t, i18n } = useTranslation();

	// Returns date with time if date is available
	const dueDate = useMemo(
		() =>
			date ? getDateTime(date, i18n.language, t) : t("main.text.notSet"),
		[date, i18n.language, t]
	);

	// Checks to see if the date is overdue or not and returns boolean
	const isOverdue = useMemo(
		() => isDateOverdue(date, i18n.language),
		[date, i18n.language]
	);

	return (
		<>
			<div className="task-card__date--desktop">
				{!isOverdue ? (
					dueDate
				) : (
					<Badge label={dueDate} className={`badge-danger`} />
				)}
			</div>
			<div className="task-card__date--mobile">
				{!isOverdue ? null : (
					<Badge label={dueDate} className={`badge-danger`} />
				)}
			</div>
		</>
	);
}
